import React from "react";
import PropTypes from "prop-types";

import "./QuickLinks.css";

import { useQuickLinks } from "../hooks/useQuickLinks";

export function QuickLinks({ onClick }) {
  const quickLinks = useQuickLinks();

  return (
    <div style={{ marginBottom: "0.5em" }}>
      {quickLinks.map(({ date, label, value }) => {
        return (
          <div
            className="snooze_option"
            key={date}
            onClick={() => {
              return onClick(date);
            }}
          >
            <span style={{ fontWeight: "bold", color: "#2185d0" }}>
              {label}
            </span>
            <span style={{ float: "right", color: "grey", fontSize: "9pt" }}>
              {value}
            </span>
          </div>
        );
      })}
    </div>
  );
}

QuickLinks.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default QuickLinks;
